module.exports = "<div class=\"js-stepper-step stepper-view_content\">&#9711</div>";